export function validateRegex(value: any, [regex]) {

    if(value === null || value === undefined || value === ''){
        return true;
    }

    if(typeof regex === 'string'){
        regex = new RegExp(regex);
    }

    return regex.test(String(value));
}

export function createRegexValidator(regex) {

    return value => validateRegex(value, [regex]);
}